import React, { Component } from 'react';
import Utils from '../../../../../utils/Utils';
import '../../styles/player.scss';

interface IPlayerProps {
    type: string;
    forward?: boolean;
    lastName: string;
    uniformNumber: string;
    classNameMovePlayer: string;
}
export default class PlayerInfo extends Component<IPlayerProps> {
    type: string;
    forward?: boolean;
    lastName: string;
    uniformNumber: string;
    classNameMovePlayer: string;

    constructor(props: IPlayerProps) {
        super(props);
        this.type = this.props.type;
        this.forward = this.props.forward;
        this.lastName = this.props.lastName || '';
        this.uniformNumber = this.props.uniformNumber || '';
        this.getClassName = this.getClassName.bind(this);
        this.classNameMovePlayer = this.props.classNameMovePlayer || '';
    }

    getClassName(): string {
        const classNameForward = this.forward ? `${this.props.type} forward` : `${this.props.type}`;
        const classNames =
            this.classNameMovePlayer && this.classNameMovePlayer !== ''
                ? `${classNameForward} ${this.classNameMovePlayer}`
                : classNameForward;

        return classNames;
    }
    render() {
        return (
            <div id="playerFormation" className={this.getClassName()}>
                <div id="circle" className={`circle-${this.type}`}>
                    <span className={`circle-dorsal-${this.type}`}>{this.uniformNumber}</span>
                </div>
                <div id="name" className={`name-${this.type}`}>
                    <span className={`name-text-${this.type}`}>
                        {Utils.cutPlayerString(this.lastName, 11, 11)}
                    </span>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/Alignment/PlayerInfo/PlayerInfo.tsx